















export default {
    name: 'GoldCoinToast',
    model: {
        prop: 'show'
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        msgObj: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            internalShow: this.show
        };
    },
    watch: {
        show(after) {
            this.internalShow = after;
        }
    },
    deactivated() {
        this.hide();
    },
    methods: {
        hide() {
            this.$emit('input', false);
        }
    }
};
